export default __webpack_public_path__ + "static/media/img2.955378dc.jpg";